const isObject = require('lodash/isObject')
const isArray = require('lodash/isArray')

module.exports = function pathTo (value, structure) {
  function pathToRecursion (path, nestedStructure) {
    if (isArray(nestedStructure)) {
      for (let i = 0; i < nestedStructure.length; i++) {
        const item = nestedStructure[i]

        const pathSoFar = [ ...path, i ]

        if (value === item) { return pathSoFar }

        const match = pathToRecursion(pathSoFar, item)

        if (match === null) continue

        return match
      }
    }

    if (isObject(nestedStructure)) {
      const entries = Object.entries(nestedStructure)

      for (const [ entryKey, entryValue ] of entries) {
        const pathSoFar = [ ...path, entryKey ]

        if (value === entryValue) { return pathSoFar }

        const match = pathToRecursion(pathSoFar, entryValue)

        if (match === null) continue

        return match
      }
    }

    return null
  }

  const initial = []

  if (value === structure) { return initial }

  return pathToRecursion(initial, structure)
}
